module.exports = __webpack_public_path__ + "static/media/img3.9e0cba60.jpg";